import { Injectable } from '@angular/core';
import { ICommunicationEvent } from '../ICommunicationEvent';
import { PlatformCommunicationEvents } from '@shared/generalInterfaces';
import { ShellContextService } from '../../../services/shell-context/shell-context.service';

@Injectable({ providedIn: 'root' })
export class TokenRefreshed implements ICommunicationEvent {
	constructor(private shellContextService: ShellContextService) {}

	get eventName(): string {
		return PlatformCommunicationEvents.TokenRefreshed;
	}

	handleEvent(event: any) {
		if (event.eventHeader.publisher !== 'platform') {
			this.shellContextService.updateContext(context => {
				context.security.accessToken = event.data.accessToken;
				context.session.sessionId = event.systemHeader.sessionId;
			});
		}
	}
}
